var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{class:_vm.align},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.openUrl($event)}}},[_c('v-icon',{attrs:{"color":"blue-grey"}},[_vm._v("open_in_new")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }